var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "row form-group" }, [
          _c("div", { staticClass: "col-2" }, [
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "manual-width" } },
              [
                _vm._v(
                  _vm._s(_vm.resource("MediaLibrary_Crop_ManualWidth_Label")) +
                    " "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: { id: "manual-width", type: "number" },
              domProps: { value: _vm.manualWidth },
              on: {
                change: function($event) {
                  return _vm.setManualWidth($event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-2" }, [
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "manual-height" } },
              [
                _vm._v(
                  _vm._s(_vm.resource("MediaLibrary_Crop_ManualHeight_Label"))
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: { id: "manual-height", type: "number" },
              domProps: { value: _vm.manualHeight },
              on: {
                change: function($event) {
                  return _vm.setManualHeight($event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-12 img-crop-container" },
            [
              _c("jcrop", {
                ref: "imageCropper",
                attrs: {
                  src: _vm.imageUrl,
                  rect: _vm.getCropRect(),
                  options: {
                    boxWidth: _vm.boxWidth,
                    boxHeight: _vm.boxHeight
                  }
                },
                on: {
                  change: _vm.imageChanged,
                  "~update": function($event) {
                    return _vm.initialize($event)
                  }
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row form-group" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary pull-right",
                on: { click: _vm.saveCrop }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.resource("MediaLibrary_CropImage_Button")) +
                    "\n            "
                )
              ]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }